export default "__VITE_ASSET__DYnpg1f___"